import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ComponentHelperService {
  constructor(private router: Router) {}

  readonly navBarWidth = signal(280);

  readonly navBarHeight = signal(56);

  readonly headerHeight = signal(92);

  public reloadComponent(isSelf: boolean, urlToNavigateTo = '/'): void {
    const url = isSelf ? this.router.url : urlToNavigateTo;

    void this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      void this.router.navigate([`/${url}`]);
    });
  }
}
